import React, { useState } from 'react';

export type WebThemeType = ReturnType<typeof getTheme>;

interface ContextProps {
  theme: WebThemeType;
  setTheme: (themeName: string) => void;
}

export const getTheme = () => {
  return {
    colors: {
      common: {
        black: '#333333',
        white: '#FFFFFF',
      },
      primary: {
        main: '#00ACD0',
        dark: '#2C7BB6',
        light: '#E5F6FA',
      },
      secondary: {
        main: '#E60075',
        dark: '#CA005D',
      },
      grey: {
        darker: '#7F7F7F',
        dark: '#B2B2B2',
        light: '#D8D8D8',
        lighter: '#ECECEC',
      },
      orange: {
        main: '#FF4500',
      },
    },
    font: {
      weight: {
        light: 300,
        book: 400,
        medium: 500,
        bold: 700,
      },
      size: {
        h1: '2rem',
        h2: '1.5rem',
        h3: '1.125rem',
        body: '1rem',
        caption: '0.875rem',
        small: '0.750rem',
        tiny: '0.625rem',
      },
    },
    spacing: {
      tiny: '0.5rem',
      small: '1rem',
      medium: '2rem',
      large: '4rem',
    },
  };
};

export const AppThemeContext = React.createContext<Partial<ContextProps>>({});

export function useTheme(): { theme: WebThemeType } {
  const defaultTheme = getTheme();
  const [selectedTheme] = useState(defaultTheme);

  return {
    theme: selectedTheme,
  };
}
